module.exports = __webpack_public_path__ + "img/越野小飞车1.2b54af3c.png";